/**
 * Product Page — Interactive Behaviors
 * Gallery, Sticky ATC, Quantity, Video, Scroll Animations
 */
document.addEventListener('DOMContentLoaded', () => {

  /* =========================================
     GALLERY — Thumbnail swap + Arrows
     ========================================= */
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const mainWrap = gallery.querySelector('#pdp-main-image');
    const images = mainWrap ? Array.from(mainWrap.querySelectorAll('img')) : [];
    const thumbs = gallery.querySelectorAll('[data-thumb-index]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    let current = 0;

    function showImage(idx) {
      if (idx < 0) idx = images.length - 1;
      if (idx >= images.length) idx = 0;
      current = idx;
      // Images are position:absolute — only opacity controls visibility (CSS transition handles fade)
      images.forEach((img, i) => { img.style.opacity = i === idx ? '1' : '0'; });
      thumbs.forEach((t, i) => { t.classList.toggle('active', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + images.length;
    }

    thumbs.forEach(t => t.addEventListener('click', () => showImage(parseInt(t.dataset.thumbIndex))));
    if (prevBtn) prevBtn.addEventListener('click', () => showImage(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => showImage(current + 1));

    // Keyboard navigation
    if (mainWrap) {
      mainWrap.setAttribute('tabindex', '0');
      mainWrap.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') showImage(current - 1);
        if (e.key === 'ArrowRight') showImage(current + 1);
      });

      // Touch swipe — horizontal drag > 40px switches image
      let touchStartX = 0;
      let touchStartY = 0;
      mainWrap.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      mainWrap.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          showImage(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }
  }

  /* =========================================
     QUANTITY STEPPER
     ========================================= */
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  const qtyInput = document.querySelector('[data-qty-input]');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, v - 1);
    });
    qtyPlus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value) || 1;
      const max = parseInt(qtyInput.max) || 99;
      qtyInput.value = Math.min(max, v + 1);
    });
  }

  /* =========================================
     AJAX ADD TO CART
     ========================================= */
  const atcForm = document.getElementById('pdp-add-to-cart-form');
  if (atcForm) {
    atcForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = atcForm.querySelector('.pdp-atc');
      const origText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Adding…</span>';

      const formData = new FormData(atcForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        btn.innerHTML = '<span>✓ Added!</span>';
        // Update cart count in header
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('[data-cart-count], .header-actions__count').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
        setTimeout(() => { btn.innerHTML = origText; btn.disabled = false; }, 2000);
      })
      .catch(() => {
        btn.innerHTML = origText;
        btn.disabled = false;
      });
    });
  }

  /* =========================================
     STICKY MOBILE ATC
     ========================================= */
  const buybox = document.querySelector('[data-buybox]');
  const stickyBar = document.querySelector('[data-sticky-atc]');
  if (buybox && stickyBar) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isMobile = window.innerWidth <= 768;
        const isDesktop = stickyBar.dataset.desktop === 'true';
        if (!entry.isIntersecting && (isMobile || isDesktop)) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(buybox);

    // Sticky bar add to cart
    const stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn && atcForm) {
      stickyBtn.addEventListener('click', () => {
        atcForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* =========================================
     VIDEO — Lazy iframe injection
     ========================================= */
  document.querySelectorAll('[data-video-block]').forEach(block => {
    const playBtn = block.querySelector('[data-video-play]');
    if (!playBtn) return;

    playBtn.addEventListener('click', () => {
      const source = block.dataset.videoSource;
      let url = block.dataset.videoUrl;
      if (!url) return;

      // Convert YouTube URL to embed
      if (source === 'youtube') {
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?]+)/);
        if (match) url = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&rel=0';
      }
      // Convert Vimeo URL to embed
      if (source === 'vimeo') {
        const match = url.match(/vimeo\.com\/(\d+)/);
        if (match) url = 'https://player.vimeo.com/video/' + match[1] + '?autoplay=1';
      }

      const poster = block.querySelector('.pdp-video__poster');
      if (poster) poster.style.display = 'none';
      playBtn.style.display = 'none';

      if (source === 'mp4') {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.style.width = '100%';
        video.style.borderRadius = '16px';
        block.appendChild(video);
      } else {
        const wrap = document.createElement('div');
        wrap.className = 'pdp-video__iframe-wrap';
        wrap.innerHTML = '<iframe src="' + url + '" allowfullscreen loading="lazy"></iframe>';
        block.appendChild(wrap);
      }
    });
  });

  /* =========================================
     HERO BACKGROUND PARALLAX (desktop only)
     ========================================= */
  const heroBg = document.querySelector('[data-parallax-bg]');
  if (heroBg && window.innerWidth >= 768) {
    const heroSection = heroBg.closest('.pdp-hero');
    function updateParallax() {
      const rect = heroSection.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const centerOffset = (rect.top + rect.height / 2 - window.innerHeight / 2);
      heroBg.style.transform = 'translateY(' + (centerOffset * 0.12) + 'px)';
    }
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  }

  /* =========================================
     DESCRIPTION ACCORDION
     ========================================= */
  document.querySelectorAll('.pdp-desc-accordion__toggle').forEach(toggle => {
    const body = toggle.closest('.pdp-desc-accordion').querySelector('.pdp-desc-accordion__body');
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      body.classList.toggle('is-open');
    });
  });

  /* =========================================
     STEP GUIDE — 1-at-a-time carousel + video autoplay
     ========================================= */
  document.querySelectorAll('[data-step-carousel]').forEach(carousel => {
    const wrap = carousel.parentElement;
    const prevBtn = wrap.querySelector('[data-step-prev]');
    const nextBtn = wrap.querySelector('[data-step-next]');
    if (!prevBtn || !nextBtn) return;

    const cards = Array.from(carousel.querySelectorAll('.pdp-steps__card'));
    const total = cards.length;
    const pdpContainer = carousel.closest('.pdp-container');
    const counterEl = pdpContainer ? pdpContainer.querySelector('[data-step-counter]') : null;
    const progressEl = pdpContainer ? pdpContainer.querySelector('[data-step-progress]') : null;
    let current = 0;

    /* Pause all videos, play only the active card's video */
    function manageVideos(activeIdx) {
      cards.forEach((card, i) => {
        const video = card.querySelector('video.pdp-steps__media');
        if (!video) return;
        if (i === activeIdx) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(total - 1, idx));
      carousel.scrollTo({ left: current * carousel.offsetWidth, behavior: 'smooth' });
      if (counterEl) counterEl.textContent = (current + 1) + ' / ' + total;
      if (progressEl) progressEl.style.width = ((current + 1) / total * 100) + '%';
      manageVideos(current);
    }

    prevBtn.addEventListener('click', () => goTo(current - 1));
    nextBtn.addEventListener('click', () => goTo(current + 1));

    /* Sync active step on manual swipe/scroll */
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = carousel.scrollLeft;
        const cardWidth = carousel.offsetWidth;
        if (cardWidth <= 0) return;
        const newIndex = Math.round(scrollLeft / cardWidth);
        if (newIndex !== current && newIndex >= 0 && newIndex < total) {
          current = newIndex;
          if (counterEl) counterEl.textContent = (current + 1) + ' / ' + total;
          if (progressEl) progressEl.style.width = ((current + 1) / total * 100) + '%';
          manageVideos(current);
        }
      }, 50); // small throttle to prevent extra computations while scrolling
    }, { passive: true });

    /* Touch swipe support */
    let touchStartX = 0;
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    /* Auto-play first video when section scrolls into view */
    const section = carousel.closest('#step-guide-section') || carousel.closest('.pdp-section');
    if (section && 'IntersectionObserver' in window) {
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            manageVideos(current);
          } else {
            /* Pause all videos when section is out of view */
            cards.forEach(card => {
              const video = card.querySelector('video.pdp-steps__media');
              if (video) { video.pause(); }
            });
          }
        });
      }, { threshold: 0.3 });
      sectionObserver.observe(section);
    }
  });

  /* Individual video scroll observer fallback (great for multiple layouts) */
  if ('IntersectionObserver' in window) {
    const stepVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.6 }); // play when at least 60% of the video is in viewport

    document.querySelectorAll('video.pdp-steps__media').forEach(video => {
      stepVideoObserver.observe(video);
    });
  }

  /* =========================================
     STEP GUIDE — Multi-card grid (auto mobile)
     ========================================= */
  document.querySelectorAll('[data-step-grid]').forEach(container => {
    const prevBtn = container.parentElement.querySelector('[data-step-prev]');
    const nextBtn = container.parentElement.querySelector('[data-step-next]');
    if (!prevBtn || !nextBtn) return;

    const card = container.querySelector('.pdp-steps__card');
    if (!card) return;

    prevBtn.addEventListener('click', () => {
      const w = window.innerWidth < 768 ? container.offsetWidth : (card.offsetWidth + 24);
      container.scrollBy({ left: -w, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      const w = window.innerWidth < 768 ? container.offsetWidth : (card.offsetWidth + 24);
      container.scrollBy({ left: w, behavior: 'smooth' });
    });
  });

  /* =========================================
     SCROLL ANIMATIONS — Fade-up
     ========================================= */
  const fadeEls = document.querySelectorAll('.pdp-fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(el => fadeObserver.observe(el));
  }

});
